// extracted by mini-css-extract-plugin
export var features = "index-module--features--f1afb";